const BaseView = require('../components/accordion-list/content');
const TemplateThumbnailView = require('../components/thumbnail/designed');

module.exports = BaseView.extend({
  apiCall: 'search/layouts',
  template: require('./template-content.hbs'),
  columnWidth: 255,

  initialize: function (options) {
    this.tool = INKIVE.Tool.getInstance();
    this.canvas = this.tool.editor.canvas;
    this.format = options.format;
    this.formats = options.formats;
    BaseView.prototype.initialize.call(this);
  },

  formatMatchesCanvas: function (format) {
    const canvasSize = {
      width: this.canvas.contentW,
      height: this.canvas.contentH
    };

    return isMatchedSize(canvasSize, getFormatDimensions(format, 96)) ||
      isMatchedSize(canvasSize, getFormatDimensions(format, 72));

    function getFormatDimensions (format, dpi) {
      const width = INKIVE.Helpers.convertUnitsToPixels(format.width, format.unit, 1, dpi);
      const height = INKIVE.Helpers.convertUnitsToPixels(format.height, format.unit, 1, dpi);

      return { width, height };
    }

    function isMatchedSize (canvas, format, threshold = 10) {
      return Math.abs(canvas.width - format.width) < threshold &&
        Math.abs(canvas.height - format.height) < threshold;
    }
  },

  getParams: function () {
    const params = {
      from: this.from,
      limit: this.limit,
      where: {
        format: this.format ? this.format.id : _.pluck(this.formats, 'id'),
        active: INKIVE.C.USER.IS_SUPER ? 0 : 1
      }
    };

    this.from += this.limit;

    return params;
  },

  render: function () {
    this.$el.html(this.template());
    this.format && this.$el.data('key', this.format.string_id);
  },

  appendThumbnails: function (data) {
    const $scrollDetect = this.$el.find('.thumbnail-wrapper .scrollDetect');

    _.each(data, function (design) {
      const $thumbnailView = $('<li>').addClass('thumbnail image loading')
        .data('key', design.id)
        .insertBefore($scrollDetect);

      new TemplateThumbnailView({
        el: $thumbnailView,
        width: this.columnWidth,
        design,
        isCustomFormat: this.isCustomFormat
      });
    }, this);
  },

  getScrollHeight: function ($target) {
    const $tabContent = $target.closest('.tab-content.inner-tabs');
    let containerHeight = $tabContent.height();

    if (INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.DESIGN || INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.DESYGNER_DESIGN) {
      containerHeight -= $tabContent.find('.header-links').height();
      containerHeight -= $target.siblings('.btn-accordion').height();
    }

    return containerHeight;
  }
});
